<div class="row align-items-center" style="border-bottom: 1px solid #5d2041; margin-top: 1px solid #5d2041; height:68.6px">
  <div class="col">
    <div class="eventsheader">My Created Events</div>
  </div>

</div> 
<div style="width:90%;margin: 0 auto; background-color:rgb(241, 235, 228);">
<mat-button-toggle-group  #group="matButtonToggleGroup" aria-label="Table Type" [(value)]="toggle" (change)="OnToggleChanged(group.value)">
  <mat-button-toggle class="status pending" value="created">
    <span [matBadgeHidden]="createdEvents.length == 0" matBadge="{{createdEvents.length}}" matBadgeOverlap="false" matBadgeColor="primary">Pending</span>
  </mat-button-toggle>
  <mat-button-toggle class="status approved" value="approved">
    <span [matBadgeHidden]="approvedEvents.length == 0" matBadge="{{approvedEvents.length}}" matBadgeOverlap="false" matBadgeColor="primary">Approved</span>
  </mat-button-toggle>
  <mat-button-toggle class="status cancelled" value="cancelled">
    <span [matBadgeHidden]="cancelledEvents.length == 0" matBadge="{{cancelledEvents.length}}" matBadgeOverlap="false" matBadgeColor="primary">Cancelled</span>
  </mat-button-toggle>
  <mat-button-toggle class="status finished" value="finished">
    <span [matBadgeHidden]="finishedEvents.length == 0" matBadge="{{finishedEvents.length}}" matBadgeOverlap="false">Finished</span>
  </mat-button-toggle>
  <mat-button-toggle class="status rejected" value="rejected">
    <span [matBadgeHidden]="rejectedEvents.length == 0" matBadge="{{rejectedEvents.length}}" matBadgeOverlap="false" matBadgeColor="primary">Rejected</span>
  </mat-button-toggle>
</mat-button-toggle-group>
</div>
<!-- <pre>
  type: {{toggle}}
</pre> -->
<!-- <span>Current Value: {{toggle}}</span>
<div *ngIf="toggle=="pending">pending</div>
<div *ngIf="toggle==approved">approved</div>
<div *ngIf="toggle==cancelled">cancelled</div>
<div *ngIf="toggle==finished">finished</div>
<div *ngIf="toggle==rejected">rejected</div> -->

<div >


  <!-- <div *ngIf="toggle== EVENT_STATUS_CREATED.toLocaleLowerCase()">event pending</div>
  <div *ngIf="toggle== EVENT_STATUS_APPROVED.toLocaleLowerCase()">event approved</div>
  <div *ngIf="toggle== EVENT_STATUS_CANCELD.toLocaleLowerCase()">event cancelled</div>
  <div *ngIf="toggle== EVENT_STATUS_FINISHED.toLocaleLowerCase()">event finished</div>
  <div *ngIf="toggle== EVENT_STATUS_REJECTED.toLocaleLowerCase()">event rejected</div> -->
<!-- <div class="container"> -->
  <div class="fulldiv" *ngIf="toggle== EVENT_STATUS_CREATED.toLocaleLowerCase()" >
    <div class="emptyeventsdiv" *ngIf="createdEvents.length == 0">
      <p class="nopending"><span class="material-icons ">
        insert_emoticon
        </span></p>
      <p class="nopending">You don't have any pending events</p>
      <p class="nopending">Do you want to <a href="/addevent"><strong>create</strong></a> an event? It's Free!</p>
    </div>

  <div class="eventdiv" *ngFor="let item of createdEvents" >
    <div *ngIf="item.events.status== EVENT_STATUS_CREATED.toLocaleLowerCase()" class="row no-gutters">
      <div class="col-sm-2">
        <img class="eventimg" src="http://events.globalistic.tech{{item.events.images[0].filename}}">
        <br>
        <div class="actionbuttons">
          <button *ngIf="item.events.status != EVENT_STATUS_CANCELD.toLocaleLowerCase()" mat-button class="editevent" routerLink='/editevent' (click)="goToUpdateEventPage(item.events)">Edit
            Event</button>
        </div>
      </div>
      <div style="margin-left: 10px;" class="col-sm">
        <div class="eventname">{{item.events.event_name}}</div>
        <div class="col-sm">
          <div [innerHTML]="item.events.description" [ngClass]="{ 'isCollapsed': !item.events.isCollapsed &&item.events.isReadMore , 'collapsed': item.events.isCollapsed&&item.events.isReadMore }" style="margin-left: 10px;">
          </div>
            <span [hidden]="!item.events.isReadMore">
              <span (click)="item.events.isCollapsed = !item.events.isCollapsed" class="readmore" style="float: right;" *ngIf="item.events.isCollapsed"><i>Read More...</i></span>
              <span (click)="item.events.isCollapsed = !item.events.isCollapsed" class="readmore" *ngIf="!item.events.isCollapsed"><i>Read Less</i></span>
            </span>
      </div>


        <!-- <p [innerHTML]="item.events.description" class="eventdescription" [class.show]="item.events.showMore"></p>
        <p class="readmore" (click)="item.events.showMore = !item.events.showMore">{{ item.events.showMore ? 'Read Less': 'Read More' }}</p> -->
      </div>
      <div class="col-sm-2">

        <button
        *ngIf="item.events.status == EVENT_STATUS_APPROVED.toLocaleLowerCase() && item.events.type != EVENT_TYPE_SPONSORED.toLocaleLowerCase()"
        routerLink='/sponsorevent' mat-button class="sponsorevent">Boost Event</button>
        <ul class="fa-ul">
          <li><span class="fa-li"><i class="fa fa-map-marker"></i></span><label class="location">{{item.events.location}}</label></li>
          <li><span class="fa-li"><i class="fa fa-clock-o"></i></span>{{item.events.start_date | date: 'MMM dd,yyyy'}}</li>
          <li><span class="fa-li"><i class="fa fa-money"></i></span>{{item.events.freeEvent}}</li>
          <li *ngIf="item.events.noWebsite" (click)="navigate(item.events.website)">
            <span class="fa-li"><i class="fa fa-link"></i></span>{{item.events.website}}
          </li>
          <li>
            <span class="fa-li"><i class="fa fa-tag"></i></span> 
            <span *ngFor="let category of item.events.category_list; let i=index">{{category.category.name}}<span>{{checkComa(item.events, i)}}</span> </span>
          </li>
          <!-- <li><span class="fa-li"><i class="fa fa-money"></i></span>{{item.events.min_fee == item.events.max_fee ? item.events.min_fee+"$" : "BETWEEN" + item.events.min_fee + "$ AND " + item.events.max_fee +"$" }}</li> -->
          <!-- <li><span class="fa-li"><i class="fa fa-eye"></i></span>{{item.events.visit == null ? 0 : item.events.visit}}</li> -->
        </ul>
      </div>
    </div>
  </div>
  </div>
  <div class="fulldiv" *ngIf="toggle== EVENT_STATUS_APPROVED.toLocaleLowerCase()" >
    <div class="emptyeventsdiv" *ngIf="approvedEvents.length == 0">
      <p class="nopending"><span class="material-icons ">
        sentiment_very_dissatisfied
        </span></p>
      <p class="nopending">You don't have any approved events</p>
      <p class="nopending">Do you want to <a href="/addevent"><strong>create</strong></a> an event? I'ts Free!</p>
    </div>
  <div class="eventdiv" *ngFor="let item of approvedEvents">
    <div class="row no-gutters">
      <div class="col-sm-2">
        <img (click)="goToEventPage(item.events)" class="eventimg" src="http://events.globalistic.tech{{item.events.images[0].filename}}">
        <br>
        <div class="actionbuttons">
          <!-- <button *ngIf="item.events.status != EVENT_STATUS_CANCELD.toLocaleLowerCase()" mat-button class="editevent" routerLink='/editevent' (click)="goToUpdateEventPage(item.events)">Edit
            Event</button> -->
          <button *ngIf="item.events.status != EVENT_STATUS_CANCELD.toLocaleLowerCase()" mat-button
            class="cancelevent" (click)="openModal(template)">Cancel Event</button>
  <ng-template #template>
    <div class="modal-body text-center">
      <h6>Are you sure you want to cancel this event?</h6>
      <p>By clicking confirm your event will be cancelled and your event will be
        removed from the calendar of all the users that picked your event,
      this action is irreversible and if you wish to get your event back you have to submit a new one </p>
      <button type="button" class="btn btn-default" (click)="confirm()" >Go Back</button>
      <button type="button" class="btn cancelevent" (click)="cancelEvent(item.events)">Confirm Cancellation</button>
    </div>
  </ng-template>
        </div>
      </div>
      <div style="margin-left: 10px;" class="col-sm">
        <div class="eventname">{{item.events.event_name}}</div>
        <div class="col-sm">
          <div [innerHTML]="item.events.description" [ngClass]="{ 'isCollapsed': !item.events.isCollapsed &&item.events.isReadMore , 'collapsed': item.events.isCollapsed&&item.events.isReadMore }" style="margin-left: 10px;">
          </div>
            <span [hidden]="!item.events.isReadMore">
              <span (click)="item.events.isCollapsed = !item.events.isCollapsed" class="readmore" style="float: right;" *ngIf="item.events.isCollapsed"><i>Read More...</i></span>
              <span (click)="item.events.isCollapsed = !item.events.isCollapsed" class="readmore" *ngIf="!item.events.isCollapsed"><i>Read Less</i></span>
            </span>
      </div>
        <!-- <p [innerHTML]="item.events.description" class="eventdescription" [class.show]="item.events.showMore"></p>
        <p class="readmore" (click)="item.events.showMore = !item.events.showMore">{{ item.events.showMore ? 'Read Less': 'Read More' }}</p> -->
      </div>
      <div class="col-sm-2">

        <button
        *ngIf="item.events.status == EVENT_STATUS_APPROVED.toLocaleLowerCase() && item.events.type != EVENT_TYPE_SPONSORED.toLocaleLowerCase()"
        routerLink='/sponsorevent' mat-button class="sponsorevent">Boost this Event</button>
        <ul class="fa-ul">
          <li><span class="fa-li"><i class="fa fa-map-marker"></i></span><label class="location">{{item.events.location}}</label></li>
          <li><span class="fa-li"><i class="fa fa-clock-o"></i></span>{{item.events.start_date | date: 'MMM dd,yyyy'}}</li>
          <li><span class="fa-li"><i class="fa fa-money"></i></span>{{item.events.freeEvent }}</li>
          <li *ngIf="item.events.noWebsite" (click)="navigate(item.events.website)">
            <span class="fa-li"><i class="fa fa-link"></i></span>{{item.events.website}}
          </li>
          <li>
            <span class="fa-li"><i class="fa fa-tag"></i></span> 
            <span *ngFor="let category of item.events.category_list; let i=index">{{category.category.name}}<span>{{checkComa(item.events, i)}}</span> </span>
          </li>
          <!-- <li><span class="fa-li"><i class="fa fa-money"></i></span>{{item.events.min_fee == item.events.max_fee ? item.events.min_fee+"$" : "BETWEEN" + item.events.min_fee + "$ AND " + item.events.max_fee +"$" }}</li> -->
          <!-- <li><span class="fa-li"><i class="fa fa-eye"></i></span>{{item.events.visit == null ? 0 : item.events.visit}}</li> -->
        </ul>
      </div>
    </div>
  </div>
</div>


<div class="fulldiv" *ngIf="toggle== EVENT_STATUS_CANCELD.toLocaleLowerCase()" >
  <div class="emptyeventsdiv" *ngIf="cancelledEvents.length == 0">
    <p class="nopending"><span class="material-icons ">
      sentiment_very_satisfied
      </span></p>
    <p class="nopending">You don't have any cancelled events</p>
    <p class="nopending">Do you want to <a href="/addevent"><strong>create</strong></a> an event? I'ts Free!</p>
  </div>
  <div class="eventdiv" *ngFor="let item of cancelledEvents">
    <div class="row no-gutters">
      <div class="col-sm-2">
        <img (click)="goToEventPage(item.events)" class="eventimg" src="http://events.globalistic.tech{{item.events.images[0].filename}}">
        <br>
        <div class="actionbuttons">
          <button *ngIf="item.events.status != EVENT_STATUS_CANCELD.toLocaleLowerCase()" mat-button class="editevent" routerLink='/editevent' (click)="goToUpdateEventPage(item.events)">Edit
            Event</button>
          <button *ngIf="item.events.status != EVENT_STATUS_CANCELD.toLocaleLowerCase()" mat-button
            class="cancelevent" (click)="openModal(template)">Cancel Event</button>
  <ng-template #template>
    <div class="modal-body text-center">
      <h6>Are you sure you want to cancel this event?</h6>
      <p>By clicking confirm your event will be cancelled and your event will be
        removed from the calendar of all the users that picked your event,
      this action is irreversible and if you wish to get your event back you have to submit a new one </p>
      <button type="button" class="btn btn-default" (click)="confirm()" >Go Back</button>
      <button type="button" class="btn cancelevent" (click)="cancelEvent(item.events)">Confirm Cancellation</button>
    </div>
  </ng-template>
        </div>
      </div>
      <div style="margin-left: 10px;" class="col-sm">
        <div class="eventname">{{item.events.event_name}}</div>

        <div class="col-sm">
          <div [innerHTML]="item.events.description" [ngClass]="{ 'isCollapsed': !item.events.isCollapsed &&item.events.isReadMore , 'collapsed': item.events.isCollapsed&&item.events.isReadMore }" style="margin-left: 10px;">
          </div>
            <span [hidden]="!item.events.isReadMore">
              <span (click)="item.events.isCollapsed = !item.events.isCollapsed" class="readmore" style="float: right;" *ngIf="item.events.isCollapsed"><i>Read More...</i></span>
              <span (click)="item.events.isCollapsed = !item.events.isCollapsed" class="readmore" *ngIf="!item.events.isCollapsed"><i>Read Less</i></span>
            </span>
      </div>
        <!-- <p [innerHTML]="item.events.description" class="eventdescription" [class.show]="item.events.showMore"></p>
        <p class="readmore" (click)="item.events.showMore = !item.events.showMore">{{ item.events.showMore ? 'Read Less': 'Read More' }}</p> -->
      </div>
      <div class="col-sm-2">

        <button
        *ngIf="item.events.status == EVENT_STATUS_APPROVED.toLocaleLowerCase() && item.events.type != EVENT_TYPE_SPONSORED.toLocaleLowerCase()"
        routerLink='/sponsorevent' mat-button class="sponsorevent">Sponsor This Event!</button>
        <ul class="fa-ul">
          <li><span class="fa-li"><i class="fa fa-map-marker"></i></span><label class="location">{{item.events.location}}</label></li>
          <li><span class="fa-li"><i class="fa fa-clock-o"></i></span>{{item.events.start_date | date: 'MMM dd,yyyy'}}</li>
          <li><span class="fa-li"><i class="fa fa-money"></i></span>{{item.events.freeEvent }}</li>
          <li *ngIf="item.events.noWebsite" (click)="navigate(item.events.website)">
            <span class="fa-li"><i class="fa fa-link"></i></span>{{item.events.website}}
          </li>
          <li>
            <span class="fa-li"><i class="fa fa-tag"></i></span> 
            <span *ngFor="let category of item.events.category_list; let i=index">{{category.category.name}}<span>{{checkComa(item.events, i)}}</span> </span>
          </li>
          <!-- <li><span class="fa-li"><i class="fa fa-money"></i></span>{{item.events.min_fee == item.events.max_fee ? item.events.min_fee+"$" : "BETWEEN" + item.events.min_fee + "$ AND " + item.events.max_fee +"$" }}</li> -->
          <!-- <li><span class="fa-li"><i class="fa fa-eye"></i></span>{{item.events.visit == null ? 0 : item.events.visit}}</li> -->
        </ul>
      </div>
    </div>
  </div>
</div>
<div class="fulldiv" *ngIf="toggle== EVENT_STATUS_FINISHED.toLocaleLowerCase()" >
  <div class="emptyeventsdiv" *ngIf="finishedEvents.length == 0">
    <p class="nopending"><span class="material-icons ">
      sentiment_very_satisfied
      </span></p>
    <p class="nopending">You don't have any finished events</p>
    <p class="nopending">Do you want to <a href="/addevent"><strong>create</strong></a> an event? I'ts Free!</p>
  </div>
  <div class="eventdiv" *ngFor="let item of finishedEvents" >
    <div class="row no-gutters">
      <div class="col-sm-2">
        <img (click)="goToEventPage(item.events)" class="eventimg" src="http://events.globalistic.tech{{item.events.images[0].filename}}">
        <br>
        <div class="actionbuttons">
          <button *ngIf="item.events.status != EVENT_STATUS_CANCELD.toLocaleLowerCase()" mat-button class="editevent" routerLink='/editevent' (click)="goToUpdateEventPage(item.events)">Edit
            Event</button>
          <!-- <button *ngIf="item.events.status != EVENT_STATUS_CANCELD.toLocaleLowerCase()" mat-button
            class="cancelevent" (click)="openModal(template)">Cancel Event</button>
  <ng-template #template>
    <div class="modal-body text-center">
      <h6>Are you sure you want to cancel this event?</h6>
      <p>By clicking confirm your event will be cancelled and your event will be
        removed from the calendar of all the users that picked your event,
      this action is irreversible and if you wish to get your event back you have to submit a new one </p>
      <button type="button" class="btn btn-default" (click)="confirm()" >Go Back</button>
      <button type="button" class="btn cancelevent" (click)="cancelEvent(item.events)">Confirm Cancellation</button>
    </div>
  </ng-template> -->
        </div>
      </div>
      <div style="margin-left: 10px;" class="col-sm">
        <div class="eventname">{{item.events.event_name}}</div>

        <div class="col-sm">
          <div [innerHTML]="item.events.description" [ngClass]="{ 'isCollapsed': !item.events.isCollapsed &&item.events.isReadMore , 'collapsed': item.events.isCollapsed&&item.events.isReadMore }" style="margin-left: 10px;">
          </div>
            <span [hidden]="!item.events.isReadMore">
              <span (click)="item.events.isCollapsed = !item.events.isCollapsed" class="readmore" style="float: right;" *ngIf="item.events.isCollapsed"><i>Read More...</i></span>
              <span (click)="item.events.isCollapsed = !item.events.isCollapsed" class="readmore" *ngIf="!item.events.isCollapsed"><i>Read Less</i></span>
            </span>
      </div>
        <!-- <p [innerHTML]="item.events.description" class="eventdescription" [class.show]="item.events.showMore"></p>
        <p class="readmore" (click)="item.events.showMore = !item.events.showMore">{{ item.events.showMore ? 'Read Less': 'Read More' }}</p> -->
      </div>
      <div class="col-sm-2">

        <button
        *ngIf="item.events.status == EVENT_STATUS_APPROVED.toLocaleLowerCase() && item.events.type != EVENT_TYPE_SPONSORED.toLocaleLowerCase()"
        routerLink='/sponsorevent' mat-button class="sponsorevent">Boost this Event</button>
        <ul class="fa-ul">
          <li><span class="fa-li"><i class="fa fa-map-marker"></i></span><label class="location">{{item.events.location}}</label></li>
          <li><span class="fa-li"><i class="fa fa-clock-o"></i></span>{{item.events.start_date | date: 'MMM dd,yyyy'}}</li>
          <li><span class="fa-li"><i class="fa fa-money"></i></span>{{item.events.freeEvent }}</li>
          <li *ngIf="item.events.noWebsite" (click)="navigate(item.events.website)">
            <span class="fa-li"><i class="fa fa-link"></i></span>{{item.events.website}}
          </li>
          <li>
            <span class="fa-li"><i class="fa fa-tag"></i></span> 
            <span *ngFor="let category of item.events.category_list; let i=index">{{category.category.name}}<span>{{checkComa(item.events, i)}}</span> </span>
          </li>
          <!-- <li><span class="fa-li"><i class="fa fa-money"></i></span>{{item.events.min_fee == item.events.max_fee ? item.events.min_fee+"$" : "BETWEEN" + item.events.min_fee + "$ AND " + item.events.max_fee +"$" }}</li> -->
          <!-- <li><span class="fa-li"><i class="fa fa-eye"></i></span>{{item.events.visit == null ? 0 : item.events.visit}}</li> -->
        </ul>
      </div>
    </div>
  </div>
</div>

<div class="fulldiv" *ngIf="toggle== EVENT_STATUS_REJECTED.toLocaleLowerCase()" >
  <div class="emptyeventsdiv" *ngIf="rejectedEvents.length == 0">
    <p class="nopending"><span class="material-icons ">
      sentiment_very_satisfied
      </span></p>
    <p class="nopending">You don't have any rejected events</p>
    <p class="nopending">Do you want to <a href="/addevent"><strong>create</strong></a> an event? I'ts Free!</p>
  </div>
  <div class="eventdiv" *ngFor="let item of rejectedEvents">
    <div class="row no-gutters">
      <div class="col-sm-2">
        <img class="eventimg" src="http://events.globalistic.tech{{item.events.images[0].filename}}">
        <br>
        <!-- <div class="actionbuttons">
          <button *ngIf="item.events.status != EVENT_STATUS_CANCELD.toLocaleLowerCase()" mat-button class="editevent" routerLink='/editevent' (click)="goToUpdateEventPage(item.events)">Edit
            Event</button> -->
          <!-- <button *ngIf="item.events.status != EVENT_STATUS_CANCELD.toLocaleLowerCase()" mat-button
            class="cancelevent" (click)="openModal(template)">Cancel Event</button>
  <ng-template #template>
    <div class="modal-body text-center">
      <h6>Are you sure you want to cancel this event?</h6>
      <p>By clicking confirm your event will be cancelled and your event will be
        removed from the calendar of all the users that picked your event,
      this action is irreversible and if you wish to get your event back you have to submit a new one </p>
      <button type="button" class="btn btn-default" (click)="confirm()" >Go Back</button>
      <button type="button" class="btn cancelevent" (click)="cancelEvent(item.events)">Confirm Cancellation</button>
    </div>
  </ng-template> -->
        <!-- </div> -->
      </div>
      <div style="margin-left: 10px;" class="col-sm">
        <div class="eventname">{{item.events.event_name}}</div>

        <div class="col-sm">
          <div [innerHTML]="item.events.description" [ngClass]="{ 'isCollapsed': !item.events.isCollapsed &&item.events.isReadMore , 'collapsed': item.events.isCollapsed&&item.events.isReadMore }" style="margin-left: 10px;">
          </div>
            <span [hidden]="!item.events.isReadMore">
              <span (click)="item.events.isCollapsed = !item.events.isCollapsed" class="readmore" style="float: right;" *ngIf="item.events.isCollapsed"><i>Read More...</i></span>
              <span (click)="item.events.isCollapsed = !item.events.isCollapsed" class="readmore" *ngIf="!item.events.isCollapsed"><i>Read Less</i></span>
            </span>
      </div>
        <!-- <p [innerHTML]="item.events.description" class="eventdescription" [class.show]="item.events.showMore"></p>
        <p class="readmore" (click)="item.events.showMore = !item.events.showMore">{{ item.events.showMore ? 'Read Less': 'Read More' }}</p> -->
      </div>
      <div class="col-sm-2">

        <button
        *ngIf="item.events.status == EVENT_STATUS_APPROVED.toLocaleLowerCase() && item.events.type != EVENT_TYPE_SPONSORED.toLocaleLowerCase()"
        routerLink='/sponsorevent' mat-button class="sponsorevent">Boost this Event</button>
        <ul class="fa-ul">
          <li><span class="fa-li"><i class="fa fa-map-marker"></i></span><label class="location">{{item.events.location}}</label></li>
          <li><span class="fa-li"><i class="fa fa-clock-o"></i></span>{{item.events.start_date | date: 'MMM dd,yyyy'}}</li>
          <li><span class="fa-li"><i class="fa fa-money"></i></span>{{item.events.freeEvent }}</li>
          <li *ngIf="item.events.noWebsite" (click)="navigate(item.events.website)">
            <span class="fa-li"><i class="fa fa-link"></i></span>{{item.events.website}}
          </li>
          <li>
            <span class="fa-li"><i class="fa fa-tag"></i></span> 
            <span *ngFor="let category of item.events.category_list; let i=index">{{category.category.name}}<span>{{checkComa(item.events, i)}}</span> </span>
          </li>
          <!-- <li><span class="fa-li"><i class="fa fa-money"></i></span>{{item.events.min_fee == item.events.max_fee ? item.events.min_fee+"$" : "BETWEEN" + item.events.min_fee + "$ AND " + item.events.max_fee +"$" }}</li> -->
          <!-- <li><span class="fa-li"><i class="fa fa-eye"></i></span>{{item.events.visit == null ? 0 : item.events.visit}}</li> -->
        </ul>
      </div>
    </div>
    </div>
  </div>


  <!-- <div class="row no-gutters">
    <div class="col-sm">
      <img class="eventimg" src="http://events.globalistic.tech{{item.images[0].filename}}">
      <br>
      <div class="actionbuttons">
        <button *ngIf="item.status != EVENT_STATUS_CANCELD.toLocaleLowerCase()" mat-button class="editevent" routerLink='/editevent' (click)="goToUpdateEventPage(item)">Edit
          Event</button>
        <button *ngIf="item.status != EVENT_STATUS_CANCELD.toLocaleLowerCase()" mat-button
          class="cancelevent" (click)="openModal(template)">Cancel Event</button>
<ng-template #template>
  <div class="modal-body text-center">
    <h6>Are you sure you want to cancel this event?</h6>
    <p>By clicking confirm your event will be cancelled and your event will be
      removed from the calendar of all the users that picked your event,
    this action is irreversible and if you wish to get your event back you have to submit a new one </p>
    <button type="button" class="btn btn-default" (click)="confirm()" >Go Back</button>
    <button type="button" class="btn cancelevent" (click)="cancelEvent(item.id)">Confirm Cancellation</button>
  </div>
</ng-template>
      </div>
    </div>
    <div>{{item.event_name}}</div>
    <div style="margin-left: 10px;" class="col-sm">
      <p class="eventdescription" [class.show]="item.showMore">{{item.description}}</p>
      <p class="readmore" (click)="item.showMore = !item.showMore">{{ item.showMore ? 'Read Less': 'Read More' }}</p>
    </div>
    <div class="col-sm">

      <button
      *ngIf="item.status == EVENT_STATUS_APPROVED.toLocaleLowerCase() && item.type != EVENT_TYPE_SPONSORED.toLocaleLowerCase()"
      routerLink='/sponsorevent' mat-button class="sponsorevent">Sponsor Event</button>
      <ul class="fa-ul">
        <li><span class="fa-li"><i class="fa fa-map-marker"></i></span><label class="location">{{item.location}}</label></li>
        <li><span class="fa-li"><i class="fa fa-clock-o"></i></span>{{item.start_date | date: 'MMM dd,yyyy'}}</li>
        <li><span class="fa-li"><i class="fa fa-money"></i></span>{{item.min_fee == item.max_fee ? item.min_fee+"$" : "BETWEEN" + item.min_fee + "$ AND " + item.max_fee +"$" }}</li>
        <li><span class="fa-li"><i class="fa fa-eye"></i></span>{{item.visit == null ? 0 : item.visit}}</li>
      </ul>
    </div>
  </div> -->

</div>

